import React from "react";
import UTILS from '../../utils/commons';


const PaymentItem = props => {
    const data = props.data;
    const className = props.className;
    return ( <div className={`${className} grid md:grid-cols-1 md:justify-start md:items-center flex-wrap border-t border-gray-100`} id="list_container">
        <div className={`grid md:grid-cols-6 p-3 text-gray-700`}>
            <span>{UTILS.formatDate( data?.createdAt )}</span>
            <span>{UTILS.paymentType( data?.type )}</span>
            <span className="font-medium">{UTILS.thousandSeparator( data?.amount )}</span>
            <span>{data?.customer?.id ? <a className="hover:underline" href={`/customers/view/${data.customer.id}`}>{data?.customer?.name || "N/A"}</a> : ( data?.customer?.name || "N/A" )}</span>
            <span>{data?.supplier?.id ? <a className="hover:underline" href={`/suppliers/view/${data.supplier.id}`}>{data?.supplier?.companyName || "N/A"}</a> : ( data?.supplier?.companyName || "N/A" )}</span>
            <span className="text-center">{data?.profile?.firstName} {data?.profile?.lastName}</span>
        </div> </div>
    )
}
export default PaymentItem;